import React, { useEffect, useState } from "react";
import { Pressable, StyleSheet, View, Image } from "react-native";
import entityStyle from "@utils/entityStyle";
import CustomText from "./CustomText";
import Cross from "@assets/svg/Cross";
import AsyncStorage from "@react-native-async-storage/async-storage";
import CompleteRegistration from "@components/CompleteRegistration";
import t from "@constants/localization";
const PATH = "screens/Home/Payment/Refund";

const PaymentRefunded = ({ leader_state }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    AsyncStorage.getItem("showRefundModal").then((data) => {
      if (!data && leader_state === "PAYMENT_REFUNDED") {
        setShowModal(true);
      }
    });
  }, []);

  const closeModal = () => {
    AsyncStorage.setItem("showRefundModal", "true");
    setShowModal(false);
  };

  return (
    <>
      {showModal && (
        <View style={[entityStyle.entityContainer, styles.container]}>
          <View style={styles.parent_view}>
            <View style={{ marginRight: 24 }}>
              <Image source={require("../assets/images/PaymentRefund.png")} />
            </View>
            <View style={{ flex: 1, marginRight: 24 }}>
              <CustomText
                variant="body_text_2"
                style={{ color: "rgba(0, 0, 0, 0.86)" }}
              >
                {t(`${PATH}/paymentRefunded`)}
              </CustomText>
            </View>
            <Pressable onPress={closeModal} style={{}}>
              <Cross width={14} height={14} />
            </Pressable>
          </View>
        </View>
      )}
      <CompleteRegistration />
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 10,
    overflow: "hidden",
    position: "relative",
    elevation: 1,
    marginBottom: 10,
    backgroundColor: "white",
  },
  parent_view: {
    backgroundColor: "#fff",
    flexDirection: "row",
    padding: 16,
    alignItems: "center",
  },
});

export default PaymentRefunded;
